import React, { Component } from "react";
import Container from "@material-ui/core/Container";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import axios from "axios/index";
import "./login.css";
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import Link from "@material-ui/core/Link";
import image from "../../../../images/ADYA.gif.gif";
// import {
//   vefification_api,
//   domain,
//   instance_type,
// } from "../../../../services/../config";
import {
  vefification_api,
  domain,
  instance_type,
} from "../../../../services/../configtest";
import styles from "./LoginForm.module.css";
import adyaImage from "../../../../images/adya_avatar.png";
import { registerServiceWorker } from "../../../../services/other_services";
import uuid from "react-uuid";
import { initializeHandlers } from "../../../../services/socketServices";

export class LoginForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLogIn: 0,
      credentials: {
        username: "",
        password: "",
      },
      logIn_request_pending: false,
      errorMessage: "",
    };

    this.setCredential = this.setCredential.bind(this);
    this.onLoginClick = this.onLoginClick.bind(this);
    this.onEnterPress = this.onEnterPress.bind(this);
  }

  setCredential(e, item) {
    let value = e.target.value;
    if (item == "username") {
      this.setState((prevState) => ({
        credentials: {
          // object that we want to update
          ...prevState.credentials, // keep all other key-value pairs
          username: value, // update the value of specific key
        },
      }));
    } else
      this.setState((prevState) => ({
        credentials: {
          // object that we want to update
          ...prevState.credentials, // keep all other key-value pairs
          password: value, // update the value of specific key
        },
      }));
  }

  onEnterPress(e) {
    if (
      e.key === "Enter" &&
      this.state.username != "" &&
      this.state.password != ""
    ) {
      this.onLoginClick();
    }
  }

  async onLoginClick() {
    // let credentials = this.state.credentials;

    this.setState({ logIn_request_pending: true });
    debugger
    console.log("pre verify otp hit")
    await axios
      .post(
        vefification_api,
        {
          // username: credentials.username,
          // password: credentials.password,
          username: "adya@ib.com",
          password: "adya@123",
          domain: domain,
          instance_type: instance_type,
        },
        { withCredentials: true }
      )
      .then(
        function (res) {
          
          //Set Conversation on new Login
          sessionStorage.setItem("conversation_id", uuid());
          initializeHandlers(res.data.userDetails);
          console.log("Post login otp")
          //Setting User Session Start
          sessionStorage.setItem("fname", res.data.userDetails.fname);
          sessionStorage.setItem("lname", res.data.userDetails.lname);
          sessionStorage.setItem("userType", res.data.userDetails.userType);
          sessionStorage.setItem("username", res.data.userDetails.username);
          sessionStorage.setItem(
            "nlp_gateway_url",
            res.data.userDetails.nlpUrl
          );
          sessionStorage.setItem("domain", domain);
          sessionStorage.setItem("instance_type", instance_type);
          sessionStorage.setItem("token", res.data.JSESSIONID);
          sessionStorage.setItem("sessionId", res.data.JSESSIONID);
          // console.log("Session ID: ", res.data.JSESSIONID);
          //Setting User Session Ends

          //************** SET user data in store loginStatus=true **********//
          this.props.set_User_Data_After_Login({
            firstName: res.data.userDetails.fname,
            lastName: res.data.userDetails.lname,
            userType: res.data.userDetails.userType,
            username: res.data.userDetails.username,
            token: res.data.JSESSIONID,
            conversation_id: sessionStorage.getItem("conversation_id"),
          });

          this.setState({ isLogIn: 1 });
          this.setState({ errorMessage: "" });
        }.bind(this)
      )
      .catch(
        function (error) {
          let errorMessage = "Not able to LogIn. Try Again!";
          if (error.response && error.response.status == 403) {
            errorMessage = "Invalid Credentials!";
            this.setState({ isLogIn: 3 });
          } else if (error.response && error.response.status == 401) {
            this.setState({ isLogIn: 2 });
            errorMessage = "Invalid Credentials!";
          } else {
            errorMessage = "Invalid Credentials!";
            this.setState({ isLogIn: 2 });
          }
          this.setState({
            errorMessage: errorMessage,
          });
        }.bind(this)
      )
      .finally(
        function () {
          this.setState({ logIn_request_pending: false });
        }.bind(this)
      );
  }

  componentDidMount() {
    this.onLoginClick();
  }

  render() {
    return (
      <React.Fragment>
        {/* <Container > */}
        {/* <p>hello</p> */}
        <div
          style={{
            backgroundColor: "#194c9f",
          }}
          className="adyagif"
        >
          <img src={image} />
        </div>
        {/* <div className="image_gif">
              <section className="micro">
                <svg
                  width="130"
                  height="130"
                  viewBox="0 0 63 63"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_d_9_54)">
                    <circle cx="31.5" cy="27.5" r="27.5" fill="#FFE8A3" />
                  </g>
                  <rect
                    x="8.92542"
                    y="4.92538"
                    width="45.1493"
                    height="45.1493"
                    fill="url(#pattern0_9_54)"
                  />
                  <defs>
                    <filter
                      id="filter0_d_9_54"
                      x="0"
                      y="0"
                      width="63"
                      height="63"
                      filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB"
                    >
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_9_54"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_9_54"
                        result="shape"
                      />
                    </filter>
                    <pattern
                      id="pattern0_9_54"
                      patternContentUnits="objectBoundingBox"
                      width="1"
                      height="1"
                    >
                      <use href="#image0_9_54" transform="scale(0.00480769)" />
                    </pattern>
                    <image
                      id="image0_9_54"
                      width="208"
                      height="208"
                      href={adyaImage}
                    />
                  </defs>
                </svg>
              </section>
            </div> */}
        {/* <FormControl>
            <InputLabel htmlFor="username">Email address</InputLabel>
            <Input
              value={this.state.credentials.username}
              id="username"
              aria-describedby="my-helper-text"
              onChange={(e) => this.setCredential(e, "username")}
              onKeyPress={(e) => this.onEnterPress(e)}
              type="email"
            />
            <FormHelperText id="username-helper-text">
              Enter Your username
            </FormHelperText>
          </FormControl> */}
        {/* <br></br> */}
        {/* <FormControl>
            <InputLabel htmlFor="password">Password</InputLabel>
            <Input
              type="password"
              id="password"
              aria-describedby="my-helper-text"
              value={this.state.credentials.password}
              onChange={(e) => this.setCredential(e, "password")}
              onKeyPress={(e) => this.onEnterPress(e)}
            />
            <FormHelperText id="password-helper-text">
              enter your password
            </FormHelperText>
          </FormControl> */}
        {/* <br />
          <FormControl>
            <Button
              variant="contained"
              color="primary"
              onClick={this.onLoginClick}
            >
              Starting Chat With ADYA
            </Button>
          </FormControl> */}

        {/* <FormControl>
            <Link
              component="button"
              variant="body2"
              onClick={() => {
                this.props.change_main_component("SignupForm");
              }}
            >
              New User? click here.
            </Link>
          </FormControl> */}

        <FormControl>
          <br />
          <br />
          {this.state.isLogIn == 1 && (
            <Alert severity="success">
              <AlertTitle>Login Success</AlertTitle>
              Welcome to Adya <strong>More than a BOT</strong>
            </Alert>
          )}
          {/* {this.state.isLogIn == 2 && (
              <Alert variant="outlined" severity="error">
                {this.state.errorMessage}
              </Alert>
            )}

            {this.state.isLogIn == 3 && (
              <Alert variant="outlined" severity="error">
                {this.state.errorMessage}
              </Alert>
            )} */}
        </FormControl>
        {/* {this.state.logIn_request_pending && (
            
            // <div>
            //   <img src={image}></img>
            // </div>
            <div>
              <img src={adyaImage}/>
            </div>

            // <FormControl>
            //   <br />
            //   <br />
            //   <Alert variant="outlined" severity="warning">
            //     Please wait..
            //   </Alert>
            // </FormControl>

            // <div className={styles.bottom_image_container}>
            //   <img
            //     // src={hermesImage}
            //     src={adyaImage}
            //     className={`${styles.rotate} ${styles.linear} ${styles.infinite}`}
            //     width="150"
            //     height="150"
            //   />
            // </div>
          )} */}
        {/* </Container> */}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    logInData: state.logInStatus,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    set_User_Data_After_Login: (logInData) => {
      dispatch({ type: "LOGIN_SUCCESS_ACTION", payload: logInData });
    },
    set_talk_to_what: (talk_to) => {
      dispatch({ type: "TALK_TO_WHAT_ACTION", payload: talk_to });
    },
    set_conversation_id: (id) => {
      dispatch({ type: "CONVERSATION_ID_ACTION", payload: id });
    },
    set_group_id: (id) => {
      dispatch({ type: "GROUP_ID_ACTION", payload: id });
    },
    set_to_participantID: (id) => {
      dispatch({ type: "TO_PARTICIPANT_ID_ACTION", payload: id });
    },
    set_from_participantID: (id) => {
      dispatch({ type: "FROM_PARTICIPANT_ID_ACTION", payload: id });
    },
    change_main_component: (componentName) => {
      dispatch({ type: "CHANGE_MAIN_COMPONENT", payload: componentName });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
